/** Formal titles — professional contexts and the global footer only. Never on buyer/seller portals. */

export const REPCSP_TITLE = "Real Estate Professionals Client Services Platform (REPCSP)";

/** @deprecated Use REPCSP_TITLE */
export const REPTP_TITLE = REPCSP_TITLE;

export const CAC_TITLE = "Client Advisor Checklist (CAC)";

export const REPTC_TITLE = "Real Estate Professional Transaction Checklist (REPTC)";

export const REPTC_SUB =
  "A professional-grade transaction workflow system for real estate advisors.";

export const REPTC_ABOUT =
  "REChecklist is the client-facing companion. REPCSP is the Real Estate Professionals Client Services Platform — the advisor desk for transactions, clients, and workflows. REPTC is the Real Estate Professional Transaction Checklist system that powers that desk. This is not a California DRE certification.";

export const REPTC_POWERED = `Powered by the ${REPCSP_TITLE}.`;
